module.exports = __webpack_public_path__ + "img/fontello.fc8c8b98.svg";